/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Europe_Paris2Inputs */

const he_timezone_europe_paris2 = /** @type {(inputs: Timezone_Europe_Paris2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paris`)
};

const en_timezone_europe_paris2 = /** @type {(inputs: Timezone_Europe_Paris2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paris`)
};

/**
* | output |
* | --- |
* | "Paris" |
*
* @param {Timezone_Europe_Paris2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_europe_paris2 = /** @type {((inputs?: Timezone_Europe_Paris2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Europe_Paris2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_europe_paris2(inputs)
	return en_timezone_europe_paris2(inputs)
});
export { timezone_europe_paris2 as "timezone_Europe_Paris" }